import axios from "axios";
import { API_URL } from "../../../config.tsx";

/**
 * Запрос автомобиля по VIN
 * @param vin - VIN автомобиля
 * @returns
 */
export const carByVinRequest = (vin: string) => {
    return axios.get(`${API_URL}/find_by_vin?vin=${vin}`, {
        withCredentials: true,
    })
        .then(response => response.data)
};
